var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100",attrs:{"id":"bg"}},[_c('UserAuthForm',{attrs:{"submit-form":_vm.loginLocal,"button-text":"Login"}}),_vm._v(" "),_c('p',{staticClass:"text-center mt-4"},[_c('b-button',{attrs:{"variant":"secondary","to":"/login/forgot"}},[_vm._v("\n      Forgot Password\n    ")]),_vm._v(".\n    ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }